import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore";
import { Box, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./NavBar.module.css";
import { routes } from "../../router/routes";
import { useConfig } from "../../context/ConfigContext";
import { useClientAccessContext } from "../../context/ClientAccessContext";

const NavigateBackItem = ({ text, route, canNavigateBack }) => {
	const { setSelectedTopic, setFromNavBar, setQueryParams } = useConfig();
	const { setSelectedClient } = useClientAccessContext();
	const navigate = useNavigate();

	const handleClick = () => {
		if (!canNavigateBack) return;
		if (route === routes.selectTopic) {
			setQueryParams({});
			setFromNavBar(true);
			setSelectedTopic(null);
		}
		if (route === routes.selectClient) {
			setFromNavBar(false);
			setSelectedClient(null);
		}

		navigate(route);
	};

	return (
		<>
			{text && (
				<Box className={styles.navigateBackItem} onClick={handleClick}>
					{canNavigateBack && <NavigateBeforeIcon color="primary" />}
					<Typography
						variant="body1"
						sx={{ textOverflow: "ellipsis", overflow: "hidden" }}
					>
						{text.charAt(0).toUpperCase() + text.slice(1)}
					</Typography>
				</Box>
			)}
		</>
	);
};
export default NavigateBackItem;
